import { useState, useEffect } from "react";

export default function WhatsAppStickyButton() {
  const [tooltipVisible, setTooltipVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setTooltipVisible(false), 6000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fixed bottom-6 right-4 md:right-8 z-50 flex flex-col items-end gap-2 mb-16 md:mb-0">
      {/* Tooltip balonu */}
      {tooltipVisible && (
        <div className="relative bg-background-50 text-foreground-800 text-xs px-3 py-2 rounded-lg shadow-lg border border-background-200/70 whitespace-nowrap animate-bounce">
          Bize WhatsApp'tan yazın
          <div className="absolute bottom-[-5px] right-5 w-2.5 h-2.5 bg-background-50 rotate-45 border-r border-b border-background-200/70"></div>
        </div>
      )}

      {/* WhatsApp butonu */}
      <a
        href="https://wa.me/905539591940"
        target="_blank"
        rel="noopener noreferrer"
        className="group relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-green-600 text-white shadow-lg hover:scale-110 transition-transform duration-300 animate-pulse-slow"
        aria-label="WhatsApp ile bize yazın"
        onClick={() => setTooltipVisible(false)}
      >
        {/* Ripple efekti */}
        <span className="absolute inset-0 rounded-full bg-green-600 opacity-75 animate-ping"></span>
        <span className="absolute inset-0 rounded-full bg-green-600"></span>
        <i className="ri-whatsapp-fill w-7 h-7 md:w-8 md:h-8 flex items-center justify-center text-2xl md:text-3xl relative z-10"></i>
      </a>
    </div>
  );
}